<template>
    <div class='student-info'>
        <div class='rank-name'>
            <gamification-profile
                :color="{color: '#000'}"
                :user="user"
                :gamificationRules="gamificationRules"
            />
        </div>
        <div class='rank-score'>{{ score }}</div>
        <div class='rank-stars'>
            <img v-if="score === 0" class="img-size" :src="`/img/gamification-0-progress.png`"/>
            <img v-else-if="stars > 0 && stars < 1" class="img-size" :src="`/img/gamification-50-progress.png`"/>
            <img v-else class="img-size" :src="`/img/gamification-100-progress.png`"/>

            <img v-if="stars <= 1" class="img-size" :src="`/img/gamification-0-progress.png`"/>
            <img v-else-if="stars > 1 && stars < 2" class="img-size" :src="`/img/gamification-50-progress.png`"/>
            <img v-else class="img-size" :src="`/img/gamification-100-progress.png`"/>

            <img v-if="stars <= 2" class="img-size" :src="`/img/gamification-0-progress.png`"/>
            <img v-else-if="stars > 2 && stars < 3" class="img-size" :src="`/img/gamification-50-progress.png`"/>
            <img v-else class="img-size" :src="`/img/gamification-100-progress.png`"/>

            <img v-if="stars <= 3" class="img-size" :src="`/img/gamification-0-progress.png`"/>
            <img v-else-if="stars > 3 && stars < 4" class="img-size" :src="`/img/gamification-50-progress.png`"/>
            <img v-else class="img-size" :src="`/img/gamification-100-progress.png`"/>

            <img v-if="stars <= 4" class="img-size" :src="`/img/gamification-0-progress.png`"/>
            <img v-else-if="stars > 4 && stars < 5" class="img-size" :src="`/img/gamification-50-progress.png`"/>
            <img v-else class="img-size" :src="`/img/gamification-100-progress.png`"/>
        </div>
    </div>
</template>
<script>
import Profile from '../NavbarComponents/NavbarProfile';
import GamificationProfile from './GamificationProfile';

export default {
    name: 'GamificationRankLine',

    components: {
        Profile,
        GamificationProfile,
    },

    props: {
        gamificationRules: Object,
        name: String,
        score: Number,
        bestScore: Number,
        user: Object,
        color: {
            type: Object,
            required: true,
        },
    },

    computed: {
        stars() {
            if (this.score > 0) {
                let percent = (this.score / this.bestScore) * 100;
                let limitedResult = Math.max(0.5, Math.min(5, percent / 20));
                let roundedResult = Math.round(limitedResult * 2) / 2;
                return roundedResult;
            }
            return 0;
        },
    },
};
</script>    
<style scoped>
    .student-info {
        background-color: #fff;
        border-radius: 50px;
        height: 75px;
        width: 70vw;
        max-width: 679px;
        display: flex;
        padding: 0 10px;
    }

    .rank-name {
        font-size: 25px;
        text-align: left;
        flex: 2;
        border-right: 5px solid #EBEBEB;
        height: 75px;
        padding-top: 20px;
        padding-left: 20px;
        color: #000;
        font-weight: 400;
    }

    .rank-score {
        font-size: 30px;
        text-align: center;
        flex: 1;
        border-right: 5px solid #EBEBEB;
        height: 75px;
        padding-top: 15px;
        color: #000;
        font-weight: 500;
    }

    .rank-stars {
        text-align: left;
        flex: 3;
        height: 50px;
        text-align: center;
        padding-top: 13px;
    }

    .img-size {
        width: 50px;
    }

    @media (max-width: 372px) {
        .img-size {
            width: 21px;
            margin-top: 4px;	
        }
        .student-info {
	        height: 55px;
            width: 93vw;
        }
        .rank-score {
            font-size: 15px;
            height: 55px;
            padding-top: 18px;
        }
        .rank-name {
            margin: -11.5px 0 0 -20px;
        }
    }

    @media (min-width: 373px) and (max-width: 424px) {
        .img-size {
            width: 21px;
            margin-top: 4px;	
        }
        .student-info {
	    height: 55px;
            width: 93vw;
        }
        .rank-score {
            font-size: 15px;
            height: 55px;
            padding-top: 18px;
        }
        .rank-name {
            margin: -11.5px 0 0 -10px;
        }
    }

    @media (min-width: 425px) and (max-width: 453px) {
        .img-size {
            width: 21px;
            margin-top: 4px;	
        }
        .student-info {
                height: 55px;
            width: 93vw;
        }
        .rank-score {
            font-size: 20px;
            height: 55px;
            padding-top: 13px;
        }
        .rank-name {
            margin: -11.5px 0 0 -10px;
        }
    }

    @media (min-width: 454px) and (max-width: 475px) {
        .img-size {
            width: 25px;
            margin-top: 2px;	
        }
        .student-info {
                height: 55px;
            width: 93vw;
        }
        .rank-score {
            font-size: 20px;
            height: 55px;
            padding-top: 13px;
        }
        .rank-name {
            margin: -11.5px 0 0 -10px;
        }
    }

    @media (min-width: 476px) and (max-width: 530px) {
        .img-size {
            width: 28.1px;
            margin-top: 0;	
        }
        .student-info {
                height: 55px;
            width: 93vw;
        }
        .rank-score {
            font-size: 20px;
            height: 55px;
            padding-top: 13px;
        }
        .rank-name {
            margin: -11.5px 0 0 -10px;
        }
    }

    @media (min-width: 531px) and (max-width: 577px) {
        .img-size {
            width: 28.1px;
            margin-top: 0;	
        }
        .student-info {
            height: 55px;
            width: 87vw;
        }
        .rank-score {
            font-size: 20px;
            height: 55px;
            padding-top: 13px;
        }
        .rank-name {
            margin: -11.5px 0 0 -10px;
        }
    }

    @media (min-width: 578px) and (max-width: 615px) {
        .img-size {
            width: 28.1px;
            margin-top: 0;	
        }
        .student-info {
                height: 55px;
            width: 80vw;
        }
        .rank-score {
            font-size: 20px;
            height: 55px;
            padding-top: 13px;
        }
        .rank-name {
            margin: -11.5px 0 0 -10px;
        }
    }

    @media (min-width: 616px) and (max-width: 659px) {
        .img-size {
            width: 28.1px;
            margin-top: 0;	
        }
        .student-info {
                height: 55px;
            width: 75vw;
        }
        .rank-score {
            font-size: 20px;
            height: 55px;
            padding-top: 13px;
        }
        .rank-name {
            margin: -11.5px 0 0 -10px;
        }
    }

    @media (min-width: 660px) and (max-width: 710px) {
        .img-size {
            width: 28.1px;
            margin-top: 0;	
        }
        .student-info {
            height: 55px;
            width: 70vw;
        }
        .rank-score {
            font-size: 20px;
            height: 55px;
            padding-top: 13px;
        }
        .rank-name {
            margin: -11.5px 0 0 -10px;
        }
    }

    @media (min-width: 711px) and (max-width: 750px) {
        .img-size {
            width: 28.1px;
            margin-top: 1px;	
        }
        .student-info {
                height: 55px;
            width: 65vw;
        }
        .rank-score {
            font-size: 20px;
            height: 55px;
            padding-top: 13px;
        }
        .rank-name {
            margin: -11.5px 0 0 -10px;
        }
    }

    @media (min-width: 751px) and (max-width: 767px) {
        .img-size {
            width: 32px;
            margin-top: 0;	
        }
        .student-info {
                height: 55px;
            width: 65vw;
        }
        .rank-score {
            font-size: 20px;
            height: 55px;
            padding-top: 13px;
        }
        .rank-name {
            margin: -10px 0 0 -10px;
        }
    }

    @media (min-width: 768px) and (max-width: 800px) {
        .img-size {
            width: 37.96px;
            margin-top: 5px;	
        }
    }

    @media (min-width: 801px) and (max-width: 860px) {
        .img-size {
            width: 41.4px;
            margin-top: 5px;	
        }
    }

    @media (min-width: 861px) and (max-width: 920px) {
        .img-size {
            width: 47.7px;
            margin-top: 1px;	
        }
    }

    @media (min-width: 921px) and (max-width: 991px) {
        .img-size {
            width: 53px;
            margin-top: -1px;	
        }
    }
</style>
    